import React, { useCallback, useEffect } from "react";

interface UseShortCutKeyProps {
  key: string;
  onKeyPress: () => void;
  active?: boolean;
}

const useShortCutKey = ({ key, onKeyPress, active = true }: UseShortCutKeyProps) => {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === key && active) {
      e.preventDefault();

      // Stop the event from bubbling up
      e.stopPropagation();
      onKeyPress();
    }
  }, [onKeyPress, active, key]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};

export default useShortCutKey;
